import classnames from 'classnames';

import './FilterIcon.css';

interface FilterIconProps {
  className?: string;
  size?: number;
}

/**
 * Filter / funnel icon. Uses currentColor for CSS-driven fills.
 */
function FilterIcon({ className, size = 24 }: FilterIconProps) {
  return (
    <svg
      aria-hidden='true'
      className={classnames('filter-icon', className)}
      fill='none'
      focusable='false'
      height={size}
      role='img'
      viewBox='0 0 24 24'
      width={size}
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0 3.46875C0 2.39062 0.84375 1.5 1.92188 1.5H22.0312C23.1094 1.5 24 2.39062 24 3.46875C24 3.9375 23.8125 4.35938 23.5312 4.6875L15.75 14.2969V21C15.75 21.8438 15.0469 22.5 14.2031 22.5C13.875 22.5 13.5469 22.4062 13.2656 22.1719L8.95312 18.75C8.48438 18.375 8.25 17.8594 8.25 17.2969V14.2969L0.421875 4.6875C0.140625 4.35938 0 3.9375 0 3.46875ZM2.57812 3.75L10.2188 13.1719C10.4062 13.4062 10.5 13.6406 10.5 13.875V17.1094L13.5 19.5V13.875C13.5 13.6406 13.5469 13.4062 13.7344 13.1719L21.4219 3.75H2.57812Z'
        fill='currentColor'
      />
    </svg>
  );
}

export default FilterIcon;
